import React from "react"
import { ButtonGroup } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import clsx from "clsx"

const SplitBottomNav = ({ children, classes, className }) => {
  return (
    <ButtonGroup
      size="large"
      color="primary"
      aria-label="large outlined primary button group"
      className={clsx(classes.root, className, "mui-fixed")}
    >
      {children}
    </ButtonGroup>
  )
}

export default withStyles(styles)(SplitBottomNav)



// WEBPACK FOOTER //
// ./src/components/SplitBottomNav/index.jsx